import { render, staticRenderFns } from "./UserAnalysisElement.vue?vue&type=template&id=07ab5530&scoped=true&"
import script from "./UserAnalysisElement.vue?vue&type=script&lang=js&"
export * from "./UserAnalysisElement.vue?vue&type=script&lang=js&"
import style0 from "./UserAnalysisElement.vue?vue&type=style&index=0&id=07ab5530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab5530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
